var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotficationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#F99E2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9506 17.2843L13.3256 16.2761C13.4145 16.863 13.1003 17.4579 12.5288 17.7006C11.9572 17.9432 11.311 17.7559 10.9506 17.2843ZM14.5724 5.39725C15.9629 6.15695 17.0067 7.13236 17.6936 8.32197C18.3804 9.51159 18.7032 10.9033 18.6659 12.4873C18.6594 12.7634 18.4303 12.9819 18.1542 12.9754C17.8782 12.9689 17.6596 12.7398 17.6661 12.4638C17.6993 11.0562 17.4185 9.84554 16.8275 8.82197C16.2366 7.79841 15.3285 6.94987 14.0929 6.27481C13.8506 6.14242 13.7615 5.83864 13.8939 5.5963C14.0263 5.35397 14.3301 5.26485 14.5724 5.39725ZM8.4725 8.34495C10.3803 7.49553 12.6086 8.2987 13.5388 10.1753L13.6044 10.3149L14.4626 12.2428L15.5948 13.2226C15.6566 13.2762 15.7101 13.3384 15.7722 13.4392L15.8113 13.5154C15.9976 13.9362 15.8074 14.4284 15.3866 14.6147L8.50213 17.6614C8.39591 17.7085 8.28103 17.7327 8.16488 17.7327C7.70464 17.7327 7.33154 17.3596 7.33154 16.8996L7.33082 15.3377L6.50257 13.4768C5.6269 11.51 6.50869 9.2193 8.4725 8.34495ZM14.414 7.79768C15.0587 8.1492 15.5753 8.66077 15.9582 9.32389C16.341 9.987 16.5257 10.6902 16.5078 11.4243C16.5011 11.7003 16.2719 11.9187 15.9958 11.9119C15.7197 11.9052 15.5014 11.676 15.5081 11.3999C15.5215 10.8522 15.3843 10.3299 15.0922 9.82388C14.8 9.31784 14.4163 8.93793 13.9353 8.67564C13.6928 8.54344 13.6035 8.23974 13.7357 7.99729C13.8679 7.75485 14.1716 7.66548 14.414 7.79768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotficationActive);
export default __webpack_public_path__ + "static/media/notficationActive.4a1e5bf4e21fa03580bd34390f643836.svg";
export { ForwardRef as ReactComponent };